// extracted by mini-css-extract-plugin
export default {"regular":"Spinner_regular__QpP8S","spinner":"Spinner_spinner__l+yRs","container":"Spinner_container__m3SFY"};